import request from '@/utils/request';
export function agencyTree(data) {
  return request.post('admin/agency/tree', data);
}
export function agencyList(data) {
  return request.post('admin/agency/list', data);
}
export function delAgency(data) {
  return request.post('admin/agency/delete', data);
}
export function agencyDetail(data) {
  return request.post('admin/agency/detail', data);
}
export const agencyLevelList = [{
  name: '总公司',
  id: 1
}, {
  name: '分公司',
  id: 2
}, {
  name: '中心支公司',
  id: 3
}, {
  name: '支公司',
  id: 4
}, {
  name: '营业部或营销服务部',
  id: 5
}, {
  name: '业务一部',
  id: 6
}, {
  name: '业务二部',
  id: 7
}];
/**图片上传 */
export const uploadFile = process.env.VUE_APP_BASE_API + 'upload/file';
export function addAgency(data) {
  return request.post('admin/agency/store', data);
}
export function editAgency(data) {
  return request.post('admin/agency/edit', data);
}
export function agencyStatus(data) {
  return request.post('admin/agency/status', data);
}
export function agencyResource(data) {
  return request.post('admin/agency/resource', data);
}